import { Controller } from "stimulus"
import {hideWin, clearHiddenWins} from "../hideWinCookie"
export default class extends Controller {
  initialize(){

  }

  static get targets(){
    return ['inputQuantity', 'modalThingy'];
  }

  submitQuantity(e){
    if( e.keyCode == 13){
      let value = this.inputQuantityTarget.value;

      if(value == "-"){
        e.preventDefault();
        hideWin(e.target.dataset.win);
        e.target.closest("tr").style.display = "none";
        document.getElementById("showSkippedLines").style.visibility = "visible";
        this.inputQuantityTarget.value = "";
      }
    }
  }
}



// WEBPACK FOOTER //
// ./app/javascript/rmrc_ad/controllers/intake_form_controller.js